import { render, staticRenderFns } from "./group-rules.mpx?vue&type=template&id=b0502374&scoped=true&component=true&componentId=group-rules31053769"
import script from "./group-rules.mpx?vue&type=script&lang=js&component=true&componentId=group-rules31053769"
export * from "./group-rules.mpx?vue&type=script&lang=js&component=true&componentId=group-rules31053769"
import style0 from "./group-rules.mpx?vue&type=style&index=0&id=b0502374&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m31053769%22%7D&component=true&componentId=group-rules31053769"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0502374",
  null
  
)

export default component.exports